if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);

            const buttonText = this.submitButton.querySelector('span');
            if (buttonText) buttonText.classList.add('hidden');

            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          this.showAddedToBagMessage();
          this.updateCartBubble();
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('Something went wrong. Please try again.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    showAddedToBagMessage() {
      let toast = document.querySelector('.gpg-cart-toast');

      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'gpg-cart-toast';
        toast.setAttribute('role', 'button');
        toast.setAttribute('tabindex', '0');

        toast.innerHTML = `
          <div class="gpg-cart-toast__icon">✓</div>
          <div class="gpg-cart-toast__text">
            <strong>Product added to bag</strong>
            <span>Click here to view your cart.</span>
          </div>
        `;

        toast.addEventListener('click', function () {
          window.location.href = window.routes?.cart_url || '/cart';
        });

        toast.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            window.location.href = window.routes?.cart_url || '/cart';
          }
        });

        document.body.appendChild(toast);
      }

      toast.classList.remove('is-visible');

      setTimeout(() => {
        toast.classList.add('is-visible');
      }, 50);

      clearTimeout(window.gpgCartToastTimer);

      window.gpgCartToastTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 3200);

      if (!document.querySelector('#gpg-cart-toast-style')) {
        const style = document.createElement('style');
        style.id = 'gpg-cart-toast-style';
        style.innerHTML = `
          .gpg-cart-toast {
            position: fixed;
            right: 24px;
            bottom: 24px;
            z-index: 999999;
            display: flex;
            align-items: center;
            gap: 14px;
            max-width: 360px;
            background: #111;
            color: #fff;
            padding: 16px 18px;
            border-radius: 16px;
            box-shadow: 0 18px 45px rgba(0,0,0,0.28);
            transform: translateY(20px);
            opacity: 0;
            pointer-events: auto;
            cursor: pointer;
            transition: all 0.25s ease;
          }

          .gpg-cart-toast.is-visible {
            transform: translateY(0);
            opacity: 1;
          }

          .gpg-cart-toast__icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: #fff;
            color: #111;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            font-weight: 900;
            flex-shrink: 0;
          }

          .gpg-cart-toast__text {
            display: flex;
            flex-direction: column;
            line-height: 1.25;
          }

          .gpg-cart-toast__text strong {
            font-size: 14px;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 0.06em;
          }

          .gpg-cart-toast__text span {
            margin-top: 3px;
            font-size: 12px;
            opacity: 0.75;
          }

          .gpg-cart-count {
            position: absolute;
            top: -8px;
            right: -10px;
            min-width: 18px;
            height: 18px;
            padding: 0 5px;
            border-radius: 999px;
            background: #111;
            color: #fff;
            font-size: 11px;
            font-weight: 900;
            line-height: 18px;
            text-align: center;
            z-index: 5;
          }

          a[href="/cart"],
          a[href$="/cart"],
          #cart-icon-bubble {
            position: relative;
          }

          @media screen and (max-width: 749px) {
            .gpg-cart-toast {
              left: 16px;
              right: 16px;
              bottom: 18px;
              max-width: none;
            }
          }
        `;
        document.head.appendChild(style);
      }
    }

    updateCartBubble() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const count = cart.item_count || 0;

          const cartLinks = document.querySelectorAll(
            '#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]'
          );

          cartLinks.forEach((cartLink) => {
            let bubble = cartLink.querySelector('.gpg-cart-count');

            if (!bubble) {
              bubble = document.createElement('span');
              bubble.className = 'gpg-cart-count';
              cartLink.appendChild(bubble);
            }

            bubble.textContent = count;

            if (count > 0) {
              bubble.style.display = 'block';
            } else {
              bubble.style.display = 'none';
            }
          });

          const dawnBubble = document.querySelector('.cart-count-bubble');

          if (dawnBubble) {
            dawnBubble.innerHTML = `
              <span aria-hidden="true">${count}</span>
              <span class="visually-hidden">${count} items</span>
            `;
            dawnBubble.style.display = count > 0 ? 'flex' : 'none';
          }
        })
        .catch((error) => {
          console.error('Cart count update error:', error);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}